export const DAYS_OF_THE_WEEK = [
  { label: 'Monday', value: '1' },
  { label: 'Tuesday', value: '2' },
  { label: 'Wednesday', value: '3' },
  { label: 'Thursday', value: '4' },
  { label: 'Friday', value: '5' },
  { label: 'Saturday', value: '6' },
  { label: 'Sunday', value: '0' },
]

export const TYPE = [
  { label: 'ONLINE', value: 'ONLINE' },
  { label: 'OFFLINE', value: 'OFFLINE' },
]

export const TIME_FORMATS = {
  AM_PM: 'h A',
  AM_PM_WITH_MINUTES: 'h:mm A',
  HOURS_MINUTES_SECONDS: 'HH:mm:ss',
  HOURS_MINUTES: 'HH:mm',
}
